import { Route } from 'react-router-dom';
import { materialDueToClubViewSchema } from './materialDueToClub';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module MaterialDueToClub
 */
const MaterialDueToClubRoutes = [
    // Route de liste (principale)
    <Route
        key="material-due-to-club"
        path="materialDueToClub"
        element={
            <Main
                key="material-due-to-club-main"
                pageConfig={materialDueToClubViewSchema}
            />
        }
    />,
];

export default MaterialDueToClubRoutes;
